import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from 'projects/forms/src/environments/environment';

export const authConfigProvider: () => AuthConfig = () => {
  return {
      issuer: environment.keycloak.issuer,
      redirectUri: getRedirectUri(),
      clientId: environment.keycloak.clientId,
      responseType: environment.keycloak.responseType,
      scope: environment.keycloak.scope,
      requireHttps: environment.keycloak.requireHttps,
      showDebugInformation: environment.keycloak.showDebugInformation,
      disableAtHashCheck: environment.keycloak.disableAtHashCheck
    }
}
export const authConfigLMSProvider: () => AuthConfig = () => {
  return {
      loginUrl: environment.lmsKeycloak.loginUrl,
    }
};

export class OAuthModuleConfig {
  resourceServer: OAuthResourceServerConfig = { sendAccessToken: false };
}

export class OAuthResourceServerConfig {
  /**
   * Urls for which calls should be intercepted.
   * If there is an ResourceServerErrorHandler registered, it is used for them.
   * If sendAccessToken is set to true, the access_token is send to them too.
   */
  allowedUrls?: Array<string>;
  sendAccessToken = true;
  customUrlValidation?: (url: string) => boolean;
}

export class AuthLSMConfig {
   /**
   * The client URL provided by auth server
   */
   loginUrl: string;
}

/**
 * Return keycloak redirect uri
 */
function getRedirectUri(): string {
  return getBaseHref() || window.location.origin;
}

/**
 * Return app base href
 */
function getBaseHref(): string | undefined {
  return document.querySelector('base')?.href;
}
